var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
var StyledDropdownDivider = styled(Dropdown.Divider)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Object.assign(StyledDropdownDivider, {
    displayName: 'DropdownDivider',
});
export default StyledDropdownDivider;
var templateObject_1;
//# sourceMappingURL=divider.js.map